<template>
  <b-container>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
    <b-modal
      ref="openModal"
      class="localizationModal"
      scrollable
      size="ml"
      title="Adicionar Novo Ponto de Parada"
      @hide="hideModal"
    >
      <!-- <div>Model WaypointModal : {{ model }}</div> -->
      <!-- point {{ point }} -->

      <waypoint-crud
        :model.sync="model"
        :modelstate="modelstate"
      ></waypoint-crud>
      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button variant="green" @click="save" :disabled="submitted">
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  name: "WaypointModal",
  components: {
    WaypointCrud: () =>
      import("@/components_rms/workflow/Waypoint/WaypointCrud.vue"),
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue")
  },
  props: {
    point: Object
  },
  data() {
    return {
      alert: {
        error: "Verefique os dados informados",
        success: "Registro criado com sucesso"
      },
      submitted: false,
      model: {
        id: 0,
        name: "",
        fullAddress: "",
        latitude: 0.0,
        longitude: 0.0
      },
      modelstate: {}
    };
  },
  methods: {
    show() {
      this.$refs.openModal.show();
    },
    save() {
      this.submitted = true;
      this.$apiWorkflow
        .post("/waypoint/save/", this.model)
        .then(response => {
          // console.log(response);
          this.$refs.alert.show();
          this.submitted = false;
          this.$emit("update:point", this.model);
          this.$forceUpdate();
          this.hideModal();
          this.$refs.openModal.hide();
        })
        .catch(error => {
          console.log(error);
          this.submitted = false;
          this.modelstate = error.response.data.errors;
          this.$refs.danger.show();
        });
    },
    hideModal() {
      this.model = {
        id: 0,
        name: "",
        fullAddress: "",
        latitude: 0.0,
        longitude: 0.0
      };
    }
  }
};
</script>
<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>
